/*global VeloxFormController,VeloxGridFormAndImporterController, VeloxWebView*/

var upload = require("../../util/upload") ;
var uuid = require("uuid") ;
var diff = require("deep-diff").diff ;
var diagController = require("../diag/diagController") ;

var customerController = new VeloxGridFormAndImporterController("customer", {
    grid : {
        directory: "views/customer",
        name: "customerGrid",
        canCreate: false, 
        canImport: false,
        openInPopup: true,
        popup: {
            size: "large"
        },
        // joinFetch : [
        //     { otherTable: "diag", name: "lastDiag", type: "2one", orderBy: "d_date desc"}
        // ]
    },
    form : {
        directory: "views/customer",
        name: "customerForm",
        buttonsHTML: require("../../views/global/form-no-buttons.html"),
        joinFetch : [
            { otherTable: "pool", type: "2one"},
            { otherTable: "spa", type: "2one"},
            { otherTable: "reseller_settings", type: "2one", name: "settings", thisField: "r_code", otherField: "r_code"},
            { otherTable: "diag", name: "diags", type: "2many", orderBy: "d_date desc", joins: [
                { otherTable: "diag_custom_product", name: "customProducts", type: "2many" }
            ]},
            { otherTable: "visit", name: "visits", type: "2many", orderBy: "v_date desc"},
            { otherTable: "doc", name: "docs", type: "2many", joins: [
                { otherTable: "velox_binary", name: "binary", thisField: "doc_id", otherField:"table_uid" , joinSearch: {"table_name": "doc"}},
            ]},
        ]
    },
    importer: {
        name: "customerImporter",
        openInPopup: true,
        popup: {
            size: "large",
            title: ""
        }
    }
});

/**
 * Get the default data when create a new record
 * 
 * @return {object} based on defaultData option with VeloxFormController.UUID_AUTO replaced
 */
customerController.formController.getDefaultData = function(callback){
    this.api.api.multiread({
        reseller_settings: {
            searchFirst: { r_code: this.api.currentUser.realms[0].realm.code }
        }
    }, function(err, reads){
        if(err){ return callback(err) ; }
        callback(null,{
            settings: reads.reseller_settings,
            r_code : this.api.currentUser.realms[0].realm.code
        });
    }.bind(this))
} ;


/**
 * Override openrecord to manage the search grid in popup (instead of classical grid > form navigation)
 * @param {*} ev 
 */
customerController._onOpenRecord = function(ev){
    var routeData = customerController.gridController.routeData ;
    var record = ev.data ;
    var destination = "/"+this.formRoute ;
    if(routeData && routeData.d){
        destination = routeData.d ;
    }
    this.navigate(destination, {c: record.c_id}) ;
} ;

/**
 * When grid open, fill the search with param in url (route data)
 */
customerController.gridController.onDisplayed = function(){
    var inputSearch = "";
    if(this.routeData && this.routeData.s){
        inputSearch = this.routeData.s;
    }
    this.view.EL.customerGrid.search(inputSearch) ;
} ;

customerController.formController.onBeforeRender = function(){
    this.data.hasRespectProducts = false;
    if(VeloxWebView.i18n.getLang()  === "fr-FR" || VeloxWebView.i18n.getLang()  === "fr" ||
        VeloxWebView.i18n.getLang()  === "de-DE" || VeloxWebView.i18n.getLang()  === "de"){
        this.data.hasRespectProducts = true;
    }
} ;

customerController.gridController.onDeleteSelectedCustomers = function(){
    if(this.api.licenseErr){
        return VeloxWebView.error(VeloxWebView.tr("mustHaveLicense")) ;
    }
    var selection = this.view.EL.customerGrid.getSelection() ;
    if(selection.length === 0){
        return this.view.error(this.view.tr("welcome.noCustomerSelected")) ;
    }
    this.view.confirm(this.view.tr("welcome.confirmDelete"),  {
        yesLabel: this.view.tr("welcome.confirmDeleteYes"),
        noLabel: this.view.tr("customers.confirmDeleteNo"),
        focusToNoButton: true
    }, function(yes){
        if(yes){
            this.view.longTask(function(done){
                var records = [] ;
                this.api.api.diag.search({c_id: {ope: "in", value: selection.map(function(r){ return r.c_id; })}}, [{otherTable : "diag_custom_product", type: "2many"}], function(err, diags){
                    if(err){ return done(err); }
                    diags.forEach(function(diag){
                        diag.diag_custom_product.forEach(function(p){
                            records.push(
                                {action : "remove", table: "diag_custom_product", record: {dcp_id: p.dcp_id}}
                            );
                        });
                    });
                    selection.forEach(function(record){
                        records = records.concat([
                            {action : "removeWhere", table: "spa", record: {c_id: record.c_id}},
                            {action : "removeWhere", table: "pool", record: {c_id: record.c_id}},
                            {action : "removeWhere", table: "diag", record: {c_id: record.c_id}},
                            {action : "removeWhere", table: "doc", record: {c_id: record.c_id}},
                            {action : "removeWhere", table: "visit", record: {c_id: record.c_id}},
                            {action : "remove", table: "customer", record: record}
                        ]) ;
                    }) ;
                    this.api.api.transactionalChanges(records, function(err){
                        if(err){ return done(err); }
                        this.refresh(done) ;
                    }.bind(this)) ;
                }.bind(this)) ;
            }.bind(this)) ;
        }
    }.bind(this)) ;
};


customerController.formController.prepareDataOnEnter = function(data, callback){
    var data = data && data.c ? data.c : data;

    VeloxFormController.prototype.prepareDataOnEnter.call(this,data, callback) ;
} ;

customerController.formController._onBtValidate = function(){
    if(this.api.licenseErr){
        return VeloxWebView.error(VeloxWebView.tr("mustHaveLicense")) ;
    }
    VeloxFormController.prototype._onBtValidate.apply(this) ;
};

customerController.formController._onBtDelete = function(){
    if(this.api.licenseErr){
        return VeloxWebView.error(VeloxWebView.tr("mustHaveLicense")) ;
    }
    VeloxFormController.prototype._onBtDelete.apply(this) ;
};

/**
 * Open the grid when user search
 * @param {*} ev 
 */
customerController.formController.onSearch = function(ev){
    var inputSearch = ev.data ;
    this.navigate("~"+customerController.baseRoute, {s: inputSearch}) ;
} ;

/**
 * Open a new diag for this customer
 */
customerController.formController.onDuplicateDiag = function(ev){
    if(this.api.licenseErr){
        return VeloxWebView.error(VeloxWebView.tr("mustHaveLicense")) ;
    }
    if(!customerController.formController.checkRequiredData()){
        return;
    }
    this.navigate("/diag/form", {copy: ev.data.data.d_id}) ;
} ;

/**
 * Open a new diag for this customer
 */
customerController.formController.onNewDiag = function(){
    if(this.api.licenseErr){
        return VeloxWebView.error(VeloxWebView.tr("mustHaveLicense")) ;
    }
    if(!customerController.formController.checkRequiredData()){
        return;
    }
    this.navigate("/diag/form", {c: this.data.c_id}) ;
} ;

customerController.formController.checkRequiredData = function(){
    var customer = this.data ;
    var poolInfoMissing = (
        !customer.pool || !customer.pool.p_disinfectant || 
        !customer.pool.p_filter || !customer.pool.p_volume
    );
    var spaInfoMissing = (
        !customer.spa || !customer.spa.s_disinfectant || 
        !customer.spa.s_filter || !customer.spa.s_volume
    );
    if(poolInfoMissing && spaInfoMissing){
        VeloxWebView.error(VeloxWebView.tr("diag.missingRequiredFieldOnCustomer")) ;
        return false;
    }
    return true;
} ;



/**
 * Open an existing diag
 */
customerController.formController.onOpenDiag = function(ev){
    var diag = JSON.parse(JSON.stringify(ev.data.data)) ;
    diag.customer = this.data ;
    diag.readOnly = true;
    diagController.formController.openReport(diag, 'VIEW') ;
} ;

/**
 * Delete a diag
 */
customerController.formController.onDeleteDiag = function(ev){
    if(this.api.licenseErr){
        return VeloxWebView.error(VeloxWebView.tr("mustHaveLicense")) ;
    }
    customerController.formController.view.question(VeloxWebView.tr("customers.confirmDeleteDiag"),
                {size: "medium"},
                [
                    {label: VeloxWebView.tr("customers.confirmDeleteDiagYes"), code: "delete", className: "btn-outline-danger"},
                    {label: VeloxWebView.tr("customers.confirmDeleteDiagNo"), code: "cancel", className: "btn-outline-secondary", focus: true, isDefault: true}
                ], function(answer){
                    if(answer === "delete"){
                        this.view.longTask(function(done){
                            this.api.api.transactionalChanges([
                                {table: "extrabat_diag", action : "removeWhere", record: {d_id: ev.data.data.d_id}},
                                {table: "diag_custom_product", action: "removeWhere", record: {d_id: ev.data.data.d_id}},
                                {table: "diag", action: "remove", record: {d_id: ev.data.data.d_id}}
                            ], function(err){
                                if(err){ return done(err); }
                                this.refresh(done);
                            }.bind(this)) ;
                        }.bind(this)) ;
                    }
    }.bind(this)) ;
} ;

customerController.formController.onNewVisit = function(ev){
    var viewVisit = new VeloxWebView("views/customer", "visitPopup", {bindObject: { v_date: new Date()}}) ;
    viewVisit.openInPopup({
        size:"medium",
        title: " "
    })  ;
    viewVisit.on("validate",function(){
        this.view.longTask(function(done){
            viewVisit.checkForm(function(err, checkOk){
                if(err){return done(err) ;}
                if(!checkOk){ return done() ;}
                var visit = viewVisit.getData() ;
                visit.v_id = uuid.v4() ;
                visit.c_id = this.data.c_id ;
                var records = [];
                records.push({
                    table : "visit",
                    record : visit,
                    action: "insert"
                }) ;
                this.api.api.transactionalChanges(records, function(err){
                    if(err){return done(err) ;}
                    done();
                    viewVisit.close() ;
                    this.refresh() ;
                }.bind(this)) ;
            }.bind(this)) ;
        }.bind(this)) ;
    }.bind(this)) ;
} ;


customerController.formController.onOpenVisit = function(ev){
    var visit = ev.data.data ;
    var viewVisit = new VeloxWebView("views/customer", "visitPopup", {bindObject: visit}) ;
    viewVisit.openInPopup({
        size:"medium",
        title: " "
    })  ;
    viewVisit.on("delete",function(){
        this.view.confirm(VeloxWebView.tr("customer.areYouSureDeleteVisit"), function(yes){
            if(yes){
                this.view.longTask(function(done){
                    var records = [];
                    records.push({
                        table : "visit",
                        record : visit,
                        action: "remove"
                    }) ;
                    this.api.api.transactionalChanges(records, function(err){
                        if(err){return done(err) ;}
                        done();
                        viewVisit.close() ;
                        this.refresh() ;
                    }.bind(this)) ;
                }.bind(this)) ;
            }
        }.bind(this)) ;
    }.bind(this));
    viewVisit.on("validate",function(){
        this.view.longTask(function(done){
            viewVisit.checkForm(function(err, checkOk){
                if(err){return done(err) ;}
                if(!checkOk){ return done() ;}
                viewVisit.updateData() ;
                var records = [];
                records.push({
                    table : "visit",
                    record : visit,
                    action: "update"
                }) ;
                this.api.api.transactionalChanges(records, function(err){
                    if(err){return done(err) ;}
                    done();
                    viewVisit.close() ;
                    this.refresh() ;
                }.bind(this)) ;
            }.bind(this)) ;
        }.bind(this)) ;
    }.bind(this)) ;
} ;

var lastSearch = 0;
/**
 * Similar customer search on customer creation
 * @param {*} ev 
 */
customerController.formController.onSearchSimilar = function(ev){
    var thisSearch = ++lastSearch ;
    var name = ev.data ;
    if(this.mode === "create"){
        if(!name){
            return this.view.updateSimilars([]) ;
        }
        this.api.api.customer.search({c_name: name+"*"}, [{ otherTable: "diag", name: "lastDiag", type: "2one", joinOrder:"d_date DESC"}], "c_name", function(err, customers){
            if(err){
                //discard this error
            }
            if(thisSearch !== lastSearch){
                return; //a new search has been started since last search
            }

            this.view.updateSimilars(customers) ;

        }.bind(this)) ;
    }
} ;

/**
 * When user choose a similar customer, load the chosen customer
 * @param {*} ev 
 */
customerController.formController.onSimilarChosen = function(ev){
    var customer = ev.data ;
    if(customer){
        this.navigate("/customer/form", customer.c_id) ;
    }
} ;

/**
 * User request to delete a document
 * @param {*} ev 
 */
customerController.formController.onDeleteDoc = function(ev){
    var doc = ev.data ;
    this.view.confirm(this.view.tr("customers.confirmDeleteDoc"), {
        yesLabel: this.view.tr("customers.confirmDeleteDocYes"), 
        noLabel: this.view.tr("customers.confirmDeleteDiagNo"), 
        focusToNoButton: true
    }, function(yes){
        if(yes){
            this.view.longTask(function(done){
                var changes = [
                    {table: "doc", record : {doc_id: doc.doc_id}, action: "remove"},
                    {table: "velox_binary", record : {table_name: "doc", table_uid: doc.doc_id }, action: "removeWhere"}
                ] ;
                this.api.api.transactionalChanges(changes, done) ;
            }.bind(this));
        }
    }) ;
} ;
/**
 * User request to open a document
 * @param {*} ev 
 */
customerController.formController.onOpenDoc = function(ev){
    var doc = ev.data ;
    this.view.longTask(function(done){
        this.api.readBinary.download(doc.binary, done) ;
    }.bind(this));
} ;
/**
 * User upload a document
 */
customerController.formController.onUploadDoc = function(){
    upload({multiple: true},function(files){
        var calls = [] ;

        files.forEach(function(file){
            calls.push(function(cb){
                var docUid = uuid.v4() ;
                this.api.saveBinary(
                    file,
                    {
                    table_name: "doc", 
                    table_uid: docUid, 
                    mime_type: file.type,
                    description : file.name,
                    filename: file.name
                }, function(err){
                    if(err){ return cb(err); }
                    var changes = [
                        {table: "doc", record : {doc_id: docUid, c_id: this.data.c_id, doc_filename: file.name}, action: "insert"}
                    ] ;
                    this.api.api.transactionalChanges(changes, cb) ;
                }.bind(this)) ;
            }.bind(this));
        }.bind(this));


        this.view.longTask(function(done){
            VeloxWebView._asyncSeries(calls, function(err){
                if(err){ return done(err) ;}
                this.refresh(done) ;
            }.bind(this));
        }.bind(this));
    }.bind(this));
} ;

/**
 * Force modify mode when enter the customer form
 * @param {*} ev 
 */
customerController.formController.onChangeMode = function(ev){
    if(ev.data === "read"){
        this.jsonBeforeModif = JSON.stringify(this.view.getBoundObject()) ;
        this.setMode("modify") ;
    }
} ;

/**
 * remove pool or spa if no volume inputed
 */
customerController.formController.getRecordsToSave = function(viewData, dataBeforeModif, callback){
    VeloxFormController.prototype.getRecordsToSave.call(this, viewData, dataBeforeModif, function(err, recordsToSave){
        if(err){ return callback(err) ;}
        recordsToSave = recordsToSave.filter(function(record){
            return record.table === "customer" || record.table === "pool" || record.table === "spa" ;
        }) ;
        recordsToSave.forEach(function(record, i){
            if(record.table === "pool"){
                if(!record.record.p_volume){
                    if(this.mode !== "create"){
                        record.action = "remove" ;
                    }else{
                        recordsToSave.splice(i,1) ;
                    }
                }
            }
            if(record.table === "spa"){
                if(!record.record.s_volume){
                    if(this.mode !== "create"){
                        record.action = "remove" ;
                    }else{
                        recordsToSave.splice(i,1) ;
                    }
                }
            }
        }.bind(this));
        callback(null, recordsToSave) ;
    }.bind(this)) ;
};

/**
 * Add validation to check that user input at least data in POOL or in SPA
 */
customerController.formController.validations.push(function checkAtLeastPoolOrSpa(validationData){
    if(!validationData.data.pool.p_volume && !validationData.data.spa.s_volume){
        return VeloxWebView.tr("customers.atLeastPoolOrSpa");
    }
}) ;

/**
 * Check if user edited some data
 */
customerController.formController.hasChanged =  function() {
    var customerBefore = JSON.parse(JSON.stringify(this.view.getBoundObject())) ;
    var customerAfter = JSON.parse(JSON.stringify(customerBefore)) ;
    this.view.updateData(customerAfter) ;
            
    var allDiffs = diff(customerBefore, customerAfter);
    if(!allDiffs){ return false; }
    allDiffs = allDiffs.filter(function(diff){
        
        if(diff.kind === "E" && diff.rhs == diff.lhs){
            //detect a new value but it is false because the values are equals (ex number and string)
            return false;
        }
        if(diff.kind === "E" && !diff.rhs && !diff.lhs){
            //detect a new value but it is false because the values are equals ("" and null)
            return false;
        }

        if(diff.kind === "N" && !diff.rhs){
            //detect a new value but it is false because the new value is empty
            return false;
        }

        if(diff.kind === "N" && diff.path[0] === "pool" && !diff.rhs.p_volume){
            //detect a new value but it is false because the pool has not been inputed
            return false;
        }

        if(diff.kind === "N" && diff.path[0] === "spa" && !diff.rhs.s_volume){
            //detect a new value but it is false because the pool has not been inputed
            return false;
        }
        
        if(diff.kind === "N" && diff.path[0] === "docs"){
            //detect a new value but it is false because it is the list of docs
            return false;
        }
        if(diff.kind === "N" && diff.path[0] === "diags"){
            //detect a new value but it is false because it is the list of diags
            return false;
        }
        if(diff.kind === "N" && diff.path[0] === "visits"){
            //detect a new value but it is false because it is the list of visits
            return false;
        }

        return true ;
    }) ;
    console.log(allDiffs) ;
    return allDiffs.length>0;
};

customerController.formController.checkBeforeDelete = function(record, callback){
    var isUsed = false;
    callback(null, isUsed) ;
};


customerController.formController.getRecordsToDelete = function(record, callback){
    if(!record){ return callback() ; }
    this.api.api.diag.search({c_id: record.c_id}, [{otherTable : "diag_custom_product", type: "2many"}], function(err, diags){
        if(err){ return callback(err); }

        var records = [] ;

        diags.forEach(function(diag){
            diag.diag_custom_product.forEach(function(p){
                records.push(
                    {action : "remove", table: "diag_custom_product", record: {dcp_id: p.dcp_id}}
                );
            });
            records.push(
                {action : "removeWhere", table: "extrabat_diag", record: {d_id: diag.d_id}}
            );
        });
        callback(null, records.concat([
            {action : "removeWhere", table: "spa", record: {c_id: record.c_id}},
            {action : "removeWhere", table: "pool", record: {c_id: record.c_id}},
            {action : "removeWhere", table: "diag", record: {c_id: record.c_id}},
            {action : "removeWhere", table: "doc", record: {c_id: record.c_id}},
            {action : "removeWhere", table: "visit", record: {c_id: record.c_id}},
            {action : "remove", table: "customer", record: record}
        ])) ;
    }.bind(this)) ;
};

customerController.formController._onBtDelete = function(){
    this.view.confirm(this.view.tr("customers.confirmDelete"),  {
        yesLabel: this.view.tr("customers.confirmDeleteYes"),
        noLabel: this.view.tr("customers.confirmDeleteNo"),
        focusToNoButton: true
    }, function(yes){
        if(yes){
            this.view.longTask(function(done){
                this.deleteRecord(this.currentRecord, function(err){
                    if(err){ return done(err); }
                    this._toggleListAuto(false);
                    this.view.render({}) ;//render nothing in the case nobody listen to back event
                    this.navigate("/customer/form") ;
                    done() ;
                }.bind(this)) ;
            }.bind(this)) ;
        }
    }.bind(this)) ;
    
};

customerController.formController.onRemoveOptin = function(){
    this.view.confirm(this.view.tr("customers.confirmRemoveOptin"), function(yes){
        if(yes){
            this.view.longTask(function(done){
                this.api.api.customer.update({c_id: this.data.c_id, c_optin_dealer: false}, function(err){
                    if(err){ return done(err); }
                    this.refresh(done) ;
                }.bind(this)) ;
            }.bind(this)) ;
        }
    }.bind(this)) ;
    
};

/**
 * Add interceptor to check that we are not leaving the screen with not saved data (for example when click on HOME button in top menu bar)
 */
customerController.formController.on("initView", function(){
    customerController.formController.appController.addInterceptor("", function(context, next){
        if(
            context.removedRoutes.filter(function(r){ 
                return r.route === customerController.formRoute ;}).length > 0 
            ){
            //customer form is in removed route : we are moving away customer form, check non saved data
            
            if(customerController.formController.api.licenseErr){
                return next() ;
            }

            if(customerController.formController.hasChanged()){
                //data has changed, ask user what he want to do
                customerController.formController.view.question(VeloxWebView.tr("customers.confirmModified"),
                {size: "medium"},
                [
                    {label: VeloxWebView.tr("customers.confirmModifiedSaveAndContinue"), code: "save", className: "btn-outline-primary", focus: true},
                    {label: VeloxWebView.tr("customers.confirmModifiedDontSaveAndContinue"), code: "dontSave", className: "btn-outline-primary"},
                    {label: VeloxWebView.tr("customers.confirmModifiedCancel"), code: "cancel", className: "btn-outline-primary", isDefault: true}
                ], function(answer){
                    if(answer === "save"){
                        //user choose to save and leave
                        customerController.formController.view.longTask(function(done){
                            customerController.formController.doValidate(function(err, savedRecord){
                                if(err){
                                    //error, stay on the page and display error
                                    customerController.formController.appController.setCurrentRoute(context.previousPosition) ;
                                    done(err) ;
                                    return;
                                }
                                if(!savedRecord){
                                    //not saved = check failed, stay on page
                                    customerController.formController.appController.setCurrentRoute(context.previousPosition) ;
                                    done() ;
                                }else{
                                    //save OK, go to next
                                    next() ;
                                    done() ;
                                }
                            }) ;
                        }) ;
                    }else if(answer === "dontSave"){
                        //user choose not to save and leave
                        next() ;
                    }else if(answer === "cancel"){
                        //user choose to stay
                        customerController.formController.appController.setCurrentRoute(context.previousPosition) ;
                    }
                });
            }else{
                //data not changed
                next() ;
            }
        }else{
            //other route change, do nothing
            next() ;
        }
    }) ;
});

customerController.formController.onLinkToExtrabat = function(){
    this.view.longTask(function(done){
        var data = {
            c_name: this.data.c_name
        } ;

        this.api.extrabat.searchCustomer(this.api.currentReseller, data.c_name, function(err, results){
            if(err){ return done(err) ; }
            data.results = JSON.parse(results).map(function(r){
                return {
                    id: r.id,
                    c_name: r.nom,
                    c_first_name: r.prenom,
                    c_email: r.email
                } ;
            }) ;
            var viewExtrabatCustomer = new VeloxWebView("views/customer", "customerExtrabatPopup", {bindObject: data}) ;
    
            viewExtrabatCustomer.openInPopup({
                size:"medium",
                title: VeloxWebView.tr("customers.searchExtrabatCustomer")
            }, done)  ;
            viewExtrabatCustomer.on("search",function(ev){
                viewExtrabatCustomer.updateData() ;
                this.view.longTask(function(done){
                    this.api.extrabat.searchCustomer(this.api.currentReseller, data.c_name, function(err, results){
                        if(err){ return done(err) ; }
                        data.results = JSON.parse(results).map(function(r){
                            return {
                                id: r.id,
                                c_name: r.nom,
                                c_first_name: r.prenom,
                                c_email: r.email
                            } ;
                        }) ;
                        viewExtrabatCustomer.render() ;
                        done() ;
                    }.bind(this)) ;
                }.bind(this)) ;
            }.bind(this))  ;


            viewExtrabatCustomer.on("extrabatChosen",function(ev){
                var customer = this.data;
                var extrabatCustomer = ev.data;
                if(!extrabatCustomer){ return ;}
                

                this.view.longTask(function(done){
                    this.api.api.multiread({
                        diag: {
                            search : {c_id : customer.c_id},
                            joinFetch: [
                                {
                                    otherTable: "extrabat_diag", name: "extrabat"
                                }
                            ]
                        }
                    }, function(err, reads){
                        if(err){ return done(err) ;}
                        var records = [] ;
                        records.push({
                            table: "customer",
                            action: "update",
                            record: {
                                c_id: customer.c_id,
                                c_id_extrabat: extrabatCustomer.id
                            }
                        }) ;
                        reads.diag.forEach(function(diag){
                            if(!diag.extrabat){
                                records.push({
                                    table: "extrabat_diag",
                                    record: {
                                        e_code: diag.d_id,
                                        d_id: diag.d_id,
                                        r_code: customer.r_code,
                                        e_id: extrabatCustomer.id,
                                        e_status: "todo"
                                    }
                                }) ;
                            }
                        })
                        this.api.api.transactionalChanges(records, function(err){
                            if(err){return done(err) ;}

                            var calls = [function(cb){ cb() ;}] ;
                            reads.diag.forEach(function(diag){
                                if(!diag.extrabat){
                                    calls.push(function(cb){
                                        diagController.formController.createReportHTML(diag,"VIEW",function(err, diagHtml){
                                            this.api.saveBinary(
                                                new Blob([diagHtml.reportHTML], {type: 'text/html'}),
                                                {
                                                table_name: "extrabat_diag", 
                                                table_uid: diag.d_id, 
                                                mime_type: "text/html",
                                                description : "report",
                                                filename: "report.html"
                                            }, cb) ;
                                        }.bind(this)) ;
                                    }.bind(this)) ;
                                }
                            }.bind(this)) ;

                            VeloxWebView._asyncSeries(calls, function(err){
                                if(err){ return done(err) ;}
    
                                viewExtrabatCustomer.close() ;
                                this.refresh(done) ;
                                VeloxWebView.info(VeloxWebView.tr("customers.linkExtrabatSuccess")) ;
                            }.bind(this)) ;
                        }.bind(this)) ;
                    }.bind(this)) ;
                }.bind(this)) ;
            }.bind(this)) ;
        }.bind(this)) ;
    }.bind(this)) ;
} ;

customerController.formController.onCopyFromExtrabat = function(){
    this.view.updateData() ;
    this.view.longTask(function(done){
        var data = {
            c_name: ""
        } ;

       
        data.results = []
        var viewExtrabatCustomer = new VeloxWebView("views/customer", "customerExtrabatPopup", {bindObject: data}) ;

        viewExtrabatCustomer.openInPopup({
            size:"medium",
            title: VeloxWebView.tr("customers.searchExtrabatCustomer")
        }, done)  ;
        viewExtrabatCustomer.on("search",function(ev){
            viewExtrabatCustomer.updateData() ;
            this.view.longTask(function(done){
                this.api.extrabat.searchCustomer(this.api.currentReseller, data.c_name, function(err, results){
                    if(err){ return done(err) ; }
                    data.results = JSON.parse(results).map(function(r){
                        return {
                            id: r.id,
                            c_name: r.nom,
                            c_first_name: r.prenom,
                            c_email: r.email
                        } ;
                    }) ;
                    viewExtrabatCustomer.render() ;
                    done() ;
                }.bind(this)) ;
            }.bind(this)) ;
        }.bind(this))  ;


        viewExtrabatCustomer.on("extrabatChosen",function(ev){
            var customer = this.data;
            var extrabatCustomer = ev.data;
            if(!extrabatCustomer){ return ;}
            
            customer.isCreate = true;
            customer.c_name = extrabatCustomer.c_name;
            customer.c_first_name = extrabatCustomer.c_first_name;
            customer.c_email = extrabatCustomer.c_email;
            customer.c_id_extrabat = extrabatCustomer.id;
            this.view.render() ;

            viewExtrabatCustomer.close() ;

        }.bind(this)) ;
    }.bind(this)) ;
} ;
customerController.formController.onRemoveFromExtrabat = function(){
    var customer = this.data;
    this.view.longTask(function(done){
        this.api.api.transactionalChanges([
            {
                table: "customer", action: "update", 
                record: {
                    c_id: customer.c_id,
                    c_id_extrabat: null
                }
            }
        ], function(err){
            if(err){ return done(err); }
            this.refresh(done);
        }.bind(this)) ;
    }.bind(this)) ;
} ;


customerController.importerController.getRecordsToSave = function(viewData, dataBeforeModif, callback){
    if(viewData.pool && viewData.pool.p_volume){
        viewData.pool.p_volume = Math.round(Number(viewData.pool.p_volume));
        if(isNaN(viewData.pool.p_volume)){
            viewData.pool.p_volume = 0 ;
        }
    }
    if(viewData.spa && viewData.spa.s_volume){
        viewData.spa.s_volume = Math.round(Number(viewData.spa.s_volume));
        if(isNaN(viewData.spa.s_volume)){
            viewData.spa.s_volume = 0 ;
        }
    }
    VeloxFormController.prototype.getRecordsToSave.call(this, viewData, dataBeforeModif, callback) ;
};


module.exports = customerController ;